import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons'

export default class SendToAction extends Component {
    state = {
        isOpen: {},
    }
    componentDidMount() {
        // console.log('sendToaction', this.props.data)
        // console.log('sendToaction', this.props.recordGroups)
    }
    openCollapse = (index) => {
        let isOpen = this.state.isOpen

        if (!isOpen[index]) {
            isOpen[index] = false
        }
        isOpen[index] = !isOpen[index]
        this.setState({ isOpen })
    }
    render() {
        let data
        if (Array.isArray(this.props.data) && this.props.data.length != 0) {
            data = this.props.data
        } else {
            data = this.props.recordGroups

        }
        return (
            <div className='w-100'>
                <div className="pb-2">
                    <button className="flexc w-100 hover-gray p-2 br-10" onClick={this.props.lastPage}  >
                        <img width={18} src={importedIcons.arrowLeft} className="rtl-button" />
                        <p className="font-size-13 weight-500 mld-3 main-c3 text-start">  {translate(this.props.section.label)}  </p>
                    </button>
                </div>
                {this.props.data?.map((prop, index) => {
                    if (this.props.section.key == 'sprintList') {
                        return (
                            <>
                                <IntractionActionsList onClick={() => this.openCollapse(index)} language={this.props.language} data={{ title: prop.name, sub: prop.sub, shortcut: null, sub: true }} />
                                <Collapsible open={!this.state.isOpen[index]} transitionTime={100}>
                                    {/* {console.log('this.props.recordGroups', this.props.recordGroups)} */}
                                    {this.props.recordGroups && this.props.recordGroups?.map((element) => {
                                        if (element.frame == prop._id) {
                                            return (
                                                <div className='pld-3'>
                                                    <IntractionActionsList onClick={() => this.props.sendToAction(prop, element)} language={this.props.language} data={{ title: element.name, sub: element.sub, shortcut: null, }} />
                                                </div>
                                            )
                                        }
                                    })}
                                </Collapsible>
                            </>
                        )
                    }
                    else {
                        return (
                            <IntractionActionsList onClick={() => this.props.sendToAction(prop)} language={this.props.language} data={{ title: prop.name, sub: prop.sub, shortcut: null, }} />
                        )
                    }
                })}
            </div>
        )
    }
}
